/* eslint-disable react/display-name */
import { useContext, createElement } from 'react';
import _ from 'lodash';
import * as THREE from 'three';

export function getColor(id) {
  if ((id * 6) % 100 < 10) {
    return '#1abc9c';
  } else if ((id * 7) % 100 < 20) {
    return '#f39c12';
  } else if ((id * 7) % 100 < 30) {
    return '#2ecc71';
  } else if ((id * 7) % 100 < 40) {
    return '#3498db	';
  } else if ((id * 7) % 100 < 50) {
    return '#9b59b6';
  } else if ((id * 7) % 100 < 60) {
    return '#34495e';
  } else if ((id * 7) % 100 < 70) {
    return '#f1c40f';
  } else if ((id * 7) % 100 < 80) {
    return '#d35400';
  } else if ((id * 7) % 100 < 90) {
    return '#ae5a41';
  } else if ((id * 7) % 100 < 100) {
    return '#7f8c8d';
  } else {
    return '#e6e7e8';
  }
}

export function getColorWithoutHash(id) {
  if ((id * 6) % 100 < 10) {
    return '1abc9c';
  } else if ((id * 7) % 100 < 20) {
    return 'f39c12';
  } else if ((id * 7) % 100 < 30) {
    return '2ecc71';
  } else if ((id * 7) % 100 < 40) {
    return '3498db ';
  } else if ((id * 7) % 100 < 50) {
    return '9b59b6';
  } else if ((id * 7) % 100 < 60) {
    return '34495e';
  } else if ((id * 7) % 100 < 70) {
    return 'f1c40f';
  } else if ((id * 7) % 100 < 80) {
    return 'd35400';
  } else if ((id * 7) % 100 < 90) {
    return 'ae5a41';
  } else if ((id * 7) % 100 < 100) {
    return '7f8c8d';
  } else {
    return 'e6e7e8';
  }
}

export function getLayerFromStatus(id, status) {
  if (id === 0) {
    return null;
  }

  if (status != null && status.joinedDimensionsNew !== undefined) {
    for (const index in status.joinedDimensionsNew) {
      if (status.joinedDimensionsNew[index].id !== undefined && status.joinedDimensionsNew[index].id === id) {
        return status.joinedDimensionsNew[index];
      }
    }
  }

  return null;
}

export function getOrderFromStatus(id, status) {
  if (id === 0) {
    return null;
  }

  if (status != null && status.orders !== undefined) {
    for (const index in status.orders) {
      if (status.orders[index].id !== undefined && status.orders[index].id === id) {
        console.log('status.orders[index]', status.orders[index]);
        return status.orders[index];
      }
    }
  }

  return null;
}

export function getOrderFromStatusOrderQueue(id, status) {
  if (id === 0) {
    return null;
  }

  if (status != null && status.orderQueue !== undefined) {
    for (const index in status.orderQueue) {
      if (status.orderQueue[index].id !== undefined && status.orderQueue[index].id === id) {
        console.log('status.orders[index]', status.orderQueue[index]);
        return status.orderQueue[index];
      }
    }
  }

  return null;
}

export function getNumberOfLayersFromOrdersFromStatus(id, status) {
  if (id === 0) {
    return null;
  }

  if (status != null && status.orders !== undefined) {
    for (const index in status.orders) {
      if (status.orders[index].id !== undefined && status.orders[index].id === id) {
        return status.orders[index].layers.length;
      }
    }
  }

  return null;
}

export function getLayerFromOrdersFromStatus(id, status) {
  if (id === 0) {
    return null;
  }

  if (status != null && status.orderQueue !== undefined) {
    for (const index in status.orderQueue) {
      for (const layerIndex in status.orderQueue[index].layers) {
        if (status.orderQueue[index].layers[layerIndex].id !== undefined && status.orderQueue[index].layers[layerIndex].id === id) {
          return status.orderQueue[index].layers[layerIndex];
        }
      }
    }
  }

  return null;
}

export function getOrderFromLayer(id, status) {
  if (id === 0) {
    return null;
  }

  if (status != null && status.orderQueue !== undefined) {
    for (const index in status.orderQueue) {
      for (const layerIndex in status.orderQueue[index].layers) {
        if (status.orderQueue[index].layers[layerIndex].id !== undefined && status.orderQueue[index].layers[layerIndex].id === id) {
          return status.orderQueue[index];
        }
      }
    }
  }

  return null;
}

export function roundToNdecimals(num, places) {
  return +(Math.round(num + 'e+' + places) + 'e-' + places);
}

/* Add transparency value to color */
export function addOpacityToHEXColor(color, opacity) {
  let colour;
  color === undefined ? (colour = '#e1e1e1') : (colour = color);
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return colour + _opacity.toString(16).toUpperCase();
}

export function clearCacheData() {
  caches.keys().then((names) => {
    names.forEach((name) => {
      caches.delete(name);
    });
  });
  console.log('clearCacheData called!');
  // alert('Complete Cache Cleared');
}

export function addDataIntoCache(cacheName, url, response) {
  const data = new Response(JSON.stringify(response));

  if ('caches' in window) {
    // Opening given cache and putting our data into it
    caches.open(cacheName).then((cache) => {
      cache.put(url, data);
      alert('Data Added into cache!');
    });
  }
}

export function loadImageBlur() {
  console.log('loadImageBlur');

  const placeholder = document.querySelector('.placeholder');
  const small = placeholder.querySelector('.img-small');

  // 1: load small image and show it
  const img = new Image();
  img.src = small.src;
  img.onload = function () {
    small.classList.add('loaded');
  };

  // 2: load large image
  const imgLarge = new Image();
  imgLarge.src = placeholder.dataset.large;
  imgLarge.onload = function () {
    imgLarge.classList.add('loaded');
  };
  placeholder.appendChild(imgLarge);
}

export function mapReverse(reverse) {
  const reversed = reverse.map((num, index, reverse) => reverse[reverse.length - 1 - index]);
  return reversed;
}

export const forwardContext =
  (Context) =>
  (Component) =>
  ({ children, ...props }) => {
    const value = useContext(Context);
    const wrapped = createElement(Context.Provider, { value }, children);
    return createElement(Component, props, wrapped);
  };

export function diffWithSign(a, b) {
  return a > b ? Math.abs(a - b) : -Math.abs(a - b);
}

export function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));
}

export function getStripeCss(item) {
  const colors = _.get(item, 'combinedColors', []);
  let colorString = 'linear-gradient(45deg, ';
  if (_.get(colors, 'length', 0) > 0) {
    const div = (100 - colors.length) / colors.length;
    let current = 0;
    for (let i = 0; i < colors.length; i++) {
      if (i > 0) {
        colorString += ', #99999966 ' + current + '%, #99999966 ' + (current + 1) + '%,';
        current += 1;
      }
      colorString += colors[i] + ' ' + current + '%, ' + colors[i] + ' ' + (current + div) + '%';
      current += div;
    }
  }
  colorString += ')';
  return colorString;
}

export function getStripeCssFromColors(
  colors,
  useFirstColorWidth = true,
  separatorWidthPercent = 0.0 // now fully dynamic
) {
  if (!Array.isArray(colors) || colors.length === 0) return '#FFFFFF';

  const separatorColor = '#55555566';
  const numSeparators = colors.length - 1;
  const totalSeparatorPercent = numSeparators * separatorWidthPercent;

  let colorString = 'linear-gradient(45deg';
  const segments = [];

  if (useFirstColorWidth && colors.length > 1) {
    const firstWidth = 85; // first color takes 85% of the full 100%
    const remainingPercent = 100 - firstWidth - totalSeparatorPercent;
    const remainingWidth = remainingPercent / (colors.length - 1);

    segments.push(firstWidth);
    for (let i = 1; i < colors.length; i++) {
      segments.push(remainingWidth);
    }
  } else {
    const totalColorPercent = 100 - totalSeparatorPercent;
    const equalWidth = totalColorPercent / colors.length;
    for (let i = 0; i < colors.length; i++) {
      segments.push(equalWidth);
    }
  }

  let current = 0;
  for (let i = 0; i < colors.length; i++) {
    if (i > 0 && separatorWidthPercent > 0) {
      const sepEnd = current + separatorWidthPercent;
      colorString += `, ${separatorColor} ${current}%, ${separatorColor} ${sepEnd}%`;
      current = sepEnd;
    }
    const next = current + segments[i];
    colorString += `, ${colors[i]} ${current}%, ${colors[i]} ${next}%`;
    current = next;
  }

  colorString += ')';
  return colorString;
}

export const getOrdinal = (n) => {
  n = parseInt(n, 10);

  if (!Number.isFinite(n)) return undefined;

  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;

  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export function LightConstellationForLine({ model, config }) {
  const {
    isVisible = true,
    lightHeight = 15,
    scaleLightsLengthX = 1.0,
    scaleLightsLengthZ = 1.0,
    // numberOfLightsInX = 10,
    // numberOfLightsInZ = 2,
    // spacingX = null,
    // spacingZ = null,
    offsetInX = 0,
    offsetInZ = 0,
    distance = 20,
    penumbra = 1,
    decay = 2,
    intensity = 200,
    angle = Math.PI
  } = config || {};

  if (!isVisible) {
    return null;
  }
  if (model.current == null || model.current.children == null || model.current === undefined) {
    return null;
  }

  const modelChildren3DComponents = model.current.children.filter((child) => child.isObject3D);
  const boundingBoxes = modelChildren3DComponents.map((child) => new THREE.Box3().setFromObject(child));
  const isValidNumber = (value) => {
    return typeof value === 'number' && !isNaN(value) && isFinite(value);
  };
  const boundingBoxesFiltered = boundingBoxes.filter(
    (box) => isValidNumber(box.min.x) && isValidNumber(box.min.y) && isValidNumber(box.min.z) && isValidNumber(box.max.x) && isValidNumber(box.max.y) && isValidNumber(box.max.z)
  );

  if (boundingBoxes.length === 0) {
    return;
  }

  const minX = Math.min(...boundingBoxesFiltered.map((box) => box.min.x)) * scaleLightsLengthX + offsetInX;
  const maxX = Math.max(...boundingBoxesFiltered.map((box) => box.max.x)) * scaleLightsLengthX + offsetInX;
  const minZ = Math.min(...boundingBoxesFiltered.map((box) => box.min.z)) * scaleLightsLengthZ + offsetInZ;
  const maxZ = Math.max(...boundingBoxesFiltered.map((box) => box.max.z)) * scaleLightsLengthZ + offsetInZ;

  const corners = [new THREE.Vector3(minX, minZ, lightHeight), new THREE.Vector3(maxX, minZ, lightHeight), new THREE.Vector3(maxX, maxZ, lightHeight), new THREE.Vector3(minX, maxZ, lightHeight)];

  // eslint-disable-next-line no-undef
  if (onlyCorners) {
    // Only render lights at the four corners
    return (
      <group>
        {corners.map((corner, i) => (
          <spotLight key={`corner-light-${i}`} color={0xffffff} intensity={0.5} distance={100} position={corner} />
        ))}
      </group>
    );
  }

  const lightsArray = [];
  // eslint-disable-next-line no-undef
  if (calculatedSpacingX > 0 && calculatedSpacingZ > 0) {
    // eslint-disable-next-line no-undef
    for (let x = minX; x <= maxX; x += calculatedSpacingX) {
      // eslint-disable-next-line no-undef
      for (let z = minZ; z <= maxZ; z += calculatedSpacingZ) {
        const target = new THREE.Object3D();
        target.position.set(x, 0, z);
        lightsArray.push(<primitive key={`target-${x}-${z}`} object={target} />);
        lightsArray.push(
          <spotLight
            key={`light-${x}-${z}`}
            position={[x, lightHeight, z]}
            target={target}
            angle={angle}
            intensity={intensity}
            distance={distance}
            castShadow={false}
            penumbra={penumbra}
            decay={decay}
          />
        );
      }
    }
  }

  return <>{lightsArray}</>;
}

export function GridLights({ config }) {
  const {
    isVisible = true,
    lightHeight = 10,
    scaleLightsLengthX = 1.0,
    scaleLightsLengthZ = 1.0,
    numberOfLightsInX = 10,
    numberOfLightsInZ = 2,
    spacingX = null,
    spacingZ = null,
    offsetInX = 0,
    offsetInZ = 0,
    distance = 20,
    penumbra = 1,
    decay = 2,
    intensity = 200,
    angle = Math.PI,
    lengthInX = 100,
    lengthInZ = 50
  } = config || {};

  if (!isVisible) {
    return null;
  }
  const lightsArray = [];
  const calculatedSpacingX = spacingX || (numberOfLightsInX > 1 ? lengthInX / (numberOfLightsInX - 1) : lengthInX);
  const calculatedSpacingZ = spacingZ || (numberOfLightsInZ > 1 ? lengthInZ / (numberOfLightsInZ - 1) : lengthInZ);

  for (let i = 0; i < numberOfLightsInX; i++) {
    for (let j = 0; j < numberOfLightsInZ; j++) {
      const x = offsetInX + i * calculatedSpacingX * scaleLightsLengthX;
      const z = offsetInZ + j * calculatedSpacingZ * scaleLightsLengthZ;
      const target = new THREE.Object3D();
      target.position.set(x, 0, z);

      lightsArray.push(<primitive key={`target-${i}-${j}`} object={target} />);
      lightsArray.push(
        <spotLight
          key={`light-${i}-${j}`}
          position={[x, lightHeight, z]}
          target={target}
          angle={angle}
          intensity={intensity}
          distance={distance}
          castShadow={false}
          penumbra={penumbra}
          decay={decay}
        />
      );
    }
  }

  return <>{lightsArray}</>;
}
